const INITIAL_STATE = {
  step: 1,
  userId: "",
  document: "",
  user: "",
  contactId: ""
};

const multiplosReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  if (type === "TOGGLE_MULTIPLOS_STEP") {
    return {
      ...state,
      step: action.step
    };
  } else if (type === "RESET_MULTIPLOS_STATE") {
    return {
      ...state,
      step: 1
    };
  } else if (type === "MULTIMPLOS_GET_USER_ID") {
    return {
      ...state,
      userId: action.userId
    };
  } else if (type === "MULTIPLOS_GET_USER_INFO") {
    return {
      ...state,
      user: action.user,
      document: action.document
    };
  } else if (type === "MULTIPLOS_GET_CONTACT") {
    return {
      ...state,
      contactId: action.contactId,
      contact: action.contact
    };
  } else {
    return {
      ...state
    };
  }
};

export default multiplosReducer;
